const translateTableHead = (headTitle, locale) => {
  /**
   * Fonction qui récupère l'entête des tableau Excel
   * et qui retourne une traduction et un 'format' adapté
   */

  let newHead;

  switch (headTitle) {
    case 'modele':
      newHead = locale === 'fr' ? 'Modèle' : 'Model';
      break;
    case 'cylindree':
      newHead = locale === 'fr' ? 'Cylindrée' : 'Displacement';
      break;
    case 'puissance_administrative':
      newHead =
        locale === 'fr' ? 'Puissance Administrative' : 'Administrative Power';
      break;
    case 'puissance_cv':
      newHead = locale === 'fr' ? 'Puissance (cv)' : 'Power (hp)';
      break;
    case 'puissance_kw':
      newHead = locale === 'fr' ? 'Puissance (kW)' : 'Power (kW)';
      break;
    case 'vitesse_de_rotation':
      newHead =
        locale === 'fr' ? 'Vitesse de Rotation (tr/min)' : 'Speed Rate (rpm)';
      break;
    case 'frequence':
      newHead = locale === 'fr' ? 'Frequence (Hz)' : 'Frequency (Hz)';
      break;
    case 'puissance_fournie':
      newHead =
        locale === 'fr' ? 'Puissance de Sortie (kW)' : 'Output Power (kW)';
      break;
    case 'nb_cyl':
      newHead = locale === 'fr' ? 'Nombre de cylindre' : 'Number of cylinder';
      break;
    case 'transmission':
      newHead = locale === 'fr' ? 'Type de Transmission' : 'Transmission';
      break;
    case 'poids':
      newHead = locale === 'fr' ? 'Poids (kg)' : 'Weight (kg)';
      break;
    default:
      newHead = headTitle;
      break;
  }

  return newHead;
};

export default translateTableHead;



// WEBPACK FOOTER //
// ./src/utils/js/translateTableHead.js